import React from 'react';
import styles from './CartLoyaltyButton.scss';
import { TEXT_BUTTON_PRIORITY, TextButton } from '../TextButton';
import dataHooks from '../../data-hooks';
import Text from '../../core-components/Text';
import { useTranslation } from '@wix/yoshi-flow-editor';

export interface CartLoyaltyButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const CartLoyaltyButton: React.FC<CartLoyaltyButtonProps> = ({ onClick, disabled }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.buttonWrapper}>
      <TextButton
        disabled={disabled}
        priority={TEXT_BUTTON_PRIORITY.primary}
        onClick={onClick}
        data-hook={dataHooks.cartAddLoyalty}
        className={styles.fullWidthButton}
      >
        <Text typography="p2-m-colorless">{t('cart_promo_loyalty_redeem_option_CTA')}</Text>
      </TextButton>
    </div>
  );
};

CartLoyaltyButton.displayName = 'CartLoyaltyButton';

export default CartLoyaltyButton;
